// extracted by mini-css-extract-plugin
export default {"container":"Ei-z","links":"Fi-z"};